import * as NEWBuildingEvents from './events-definition'
export * from './deprecated-events-definition'
export { NEWBuildingEvents }
